import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import DeleteTwoToneIcon from "@material-ui/icons/DeleteTwoTone";
import CreateIcon from "@material-ui/icons/Create";
import { WarningModal } from "../../../common/WarningModal";
import { deleteAssignment } from "../../../backend/EditCourseDetails";
import { deleteToast, errorToast } from "../../../common/Toastify";
import { useParams } from "react-router-dom";
import ModalAssignment from "./ModalAssignment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  status: {
    color: theme.palette.info.main,
  },
  invoice: {
    color: theme.palette.error.main,
  },
  container: {
    maxHeight: 600,
    "& .MuiTableCell-stickyHeader": {
      backgroundColor: "#ffff",
    },
  },

  arrowIcon: {
    width: "30px",
    height: "30px",
  },
}));

const quizData = [];

function Row({ item }) {
  const classes = useStyles();
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [modalAssignment, setModalAssignment] = useState(false);
  const { id } = useParams();

  async function handleConfirmDelete() {
    const res = await deleteAssignment(item.id, id);
    if (res.successfull) {
      setOpenWarningModal(false);
      deleteToast("Assignment");
    } else {
      errorToast();
    }
  }

  return (
    <React.Fragment>
      <WarningModal
        open={openWarningModal}
        setOpen={setOpenWarningModal}
        message={"Assignment"}
        subMessage={"All Data will be deleted & wont be accessible anymore"}
        deleteItem={handleConfirmDelete}
      />
      <ModalAssignment
        setModalAssignment={setModalAssignment}
        modalAssignment={modalAssignment}
        assignmentDetails={item}
      />
      <TableRow className={classes.root}>
        <TableCell />
        <TableCell>{item?.title}</TableCell>
        <TableCell style={{ width: 300 }}>{item?.description}</TableCell>
        <TableCell>{item?.marks}</TableCell>
        <TableCell>{item?.submissionDate}</TableCell>
        <TableCell>
          <Button
            color="primary"
            variant="contained"
            onClick={() => window.open(item?.file, "_blank")}
          >
            Link
          </Button>
        </TableCell>
        <TableCell>
          <IconButton
            aria-label="delete"
            id={item?.docId}
            style={{ color: "#00000052", padding: 0 }}
            onClick={() => setOpenWarningModal(true)}
          >
            <DeleteTwoToneIcon />
          </IconButton>

          <IconButton
            aria-label="delete"
            id={item?.docId}
            style={{ color: "#00000052", padding: 0, marginLeft: 20 }}
            onClick={() => setModalAssignment(true)}
          >
            <CreateIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const TableAssignment = ({ assignmentData, searchVal }) => {
  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, assignmentData.length - page * rowsPerPage);
  return (
    <>
      <TableContainer className={classes.container} component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Assignment</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Total Marks</TableCell>
              <TableCell>Submission Date</TableCell>
              <TableCell>URL</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          {assignmentData?.length ? (
            <TableBody>
              {assignmentData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  return <Row key={index} item={item} />;
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          ) : (
            <TableBody>
              <TableCell>
                <p>Please Add a Order</p>
              </TableCell>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={quizData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default TableAssignment;
